import { render, staticRenderFns } from "./AppRefShareHead.vue?vue&type=template&id=26f35faa&"
import script from "./AppRefShareHead.vue?vue&type=script&lang=js&"
export * from "./AppRefShareHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports